/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useMemo, useRef, type ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";
import { createKitsosApi } from "../lib/api/kitsos";

type KitsosApi = ReturnType<typeof createKitsosApi>;
const ApiContext = createContext<KitsosApi | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const getTokenRef = useRef(auth.getToken);
  getTokenRef.current = auth.getToken;
  const api = useMemo(() => createKitsosApi(() => getTokenRef.current()), []);

  useEffect(() => () => api.dispose(), [api]);
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi() {
  const api = useContext(ApiContext);
  if (!api) throw new Error("ApiProvider missing");
  return api;
}
